import React from 'react';

import {Card, CardHeader, CardContent} from '@mui/material';
import {defineMessages, useIntl} from 'react-intl';
import {useQuery} from 'react-query';

import API, {Types} from '@wheeebo/polaris-api';

import VehicleUpdateForm from '@components/form/VehicleUpdateForm';
import {CircleLoader, LoadError, SquareChip} from '@wheeebo/polaris-ui';

const msgs = defineMessages({
  headerTitle: {
    id: 'pages.member.group.VehicleUpdateCard.header.title',
    defaultMessage: 'Vehicle Data',
  },
  headerSubTitle: {
    id: 'pages.member.group.VehicleUpdateCard.header.subTitle',
    defaultMessage: 'Basic information of this vehicle',
  },
});

interface Props {
  vehicleId: Types.UUID;
}

function VehicleUpdateCard({vehicleId}: Props): JSX.Element {
  const intl = useIntl();
  const {data, isError, isLoading} = useQuery(API.Vehicles.getKey(vehicleId, {}), () =>
    API.Vehicles.get(vehicleId, {}),
  );
  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(msgs.headerTitle)}
        subheader={intl.formatMessage(msgs.headerSubTitle)}
        action={
          <>
            {isLoading ? (
              <CircleLoader />
            ) : isError ? (
              <LoadError />
            ) : data ? (
              <SquareChip
                label={data.activationConfirmed ? 'Activated' : 'Not-activated'}
                color={data.activationConfirmed ? 'success' : 'error'}
              />
            ) : null}
          </>
        }
      />
      <CardContent>
        <VehicleUpdateForm vehicleId={vehicleId} />
      </CardContent>
    </Card>
  );
}
export default React.memo(VehicleUpdateCard);
